export const version = "sha2/5.4.0";
//# sourceMappingURL=_version.js.map